import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatThumbnail = createCustomElementWrapper('kat-thumbnail', 'KatThumbnail', {
    'altText': 'alt-text',
}, {});
